import { useRef, useState } from "react";
import { ModalPortal } from "../../SharedModule/components/ModalPortal";
import { ModalActionNonBillable } from "../components/ModalActionNonBillable";
import { ModalActionChangeDate } from "../components/ModalActionChangeDate";
import { ModalActionChangeProject } from "../components/ModalActionChangeProject";

type EntryWithUserId = {
  userId: string;
};

// Shared by QueryResultsPage and ApproveTimeByUserPage: the three bulk-action
// modals (mark non-billable, change date, change project) are wired up
// identically in both, including the project modal's affected-user list.
export const useBulkTimeEntryActionModals = <T extends EntryWithUserId>(
  entriesSelected: T[],
  updateEntriesSelected: (action: number, value: any) => Promise<void>,
  nonBillableReasons: any
) => {
  const [userListId, setUserListId] = useState<string[]>([]);

  const ModalActionNonBillableRef = useRef<undefined>(undefined);
  const showActionNonBillaleModal = () => {
    (ModalActionNonBillableRef.current as any).show(true);
  };
  const closeActionNonBillaleModal = () => {
    (ModalActionNonBillableRef.current as any).show(false);
  };

  const modalActionChangeDateRef = useRef<undefined>(undefined);
  const showActionChangeDateModal = () => {
    (modalActionChangeDateRef.current as any).show(true);
  };
  const closeActionChangeDateModal = () => {
    (modalActionChangeDateRef.current as any).show(false);
  };

  const modalActionChangeProjectRef = useRef<undefined>(undefined);
  const showActionChangeProjectModal = () => {
    let partailUserListId: string[] = [];
    entriesSelected.forEach((entry) => {
      if (!partailUserListId.includes(entry.userId)) {
        partailUserListId.push(entry.userId);
      }
    });
    setUserListId(partailUserListId);
    (modalActionChangeProjectRef.current as any).show(true);
  };
  const closeActionChangeProjectModal = () => {
    (modalActionChangeProjectRef.current as any).show(false);
  };

  const bulkActionModalsPortal = (
    <>
      <ModalPortal ref={ModalActionNonBillableRef}>
        <ModalActionNonBillable
          btnCancel={closeActionNonBillaleModal}
          btnAction={updateEntriesSelected}
          nonBillableReasons={nonBillableReasons}
        />
      </ModalPortal>
      <ModalPortal ref={modalActionChangeDateRef}>
        <ModalActionChangeDate
          btnCancel={closeActionChangeDateModal}
          btnAction={updateEntriesSelected}
        />
      </ModalPortal>
      <ModalPortal ref={modalActionChangeProjectRef}>
        <ModalActionChangeProject
          btnCancel={closeActionChangeProjectModal}
          btnAction={updateEntriesSelected}
          userListId={userListId}
        />
      </ModalPortal>
    </>
  );

  return {
    showActionNonBillaleModal,
    closeActionNonBillaleModal,
    showActionChangeDateModal,
    closeActionChangeDateModal,
    showActionChangeProjectModal,
    closeActionChangeProjectModal,
    bulkActionModalsPortal,
  };
};
